import React from "react";
import { FaInstagram } from "react-icons/fa";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(FaInstagram).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const InstagramIcon = (props) => {
  return <StyledIcon {...props} />;
};

InstagramIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default InstagramIcon;
